// extracted by mini-css-extract-plugin
export default {"small":"styles_small__mVDGw"};